(function () {
  'use strict';

  function tablerIcon(paths) {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`;
  }

  const META_ICONS = {
    people: tablerIcon(
      '<path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" /><path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /><path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />',
    ),
    clock: tablerIcon(
      '<path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M12 7v5l3 3" />',
    ),
    calendar: tablerIcon(
      '<path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" /><path d="M16 3v4" /><path d="M8 3v4" /><path d="M4 11h16" /><path d="M11 15h1" /><path d="M12 15v3" />',
    ),
    spots: tablerIcon(
      '<path d="M5 11a2 2 0 0 1 2 2v2h10v-2a2 2 0 1 1 4 0v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z" /><path d="M5 11v-5a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v5" /><path d="M6 19v2" /><path d="M18 19v2" />',
    ),
    unavailable: tablerIcon(
      '<path d="M17 13a2 2 0 1 1 4 0v4m-2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 1 1 4 0v2h8.036" /><path d="M5 11v-5a3 3 0 0 1 .134 -.89m1.987 -1.98a3 3 0 0 1 .879 -.13h8a3 3 0 0 1 3 3v5" /><path d="M6 19v2" /><path d="M18 19v2" /><path d="M3 3l18 18" />',
    ),
  };

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getConfig(section) {
    return {
      courseId: section.dataset.courseId,
      backendUrl: (section.dataset.backendUrl || 'https://api.ultramaszyna.com').replace(/\/$/, ''),
      productTitle: section.dataset.productTitle || '',
      signupLabel: section.dataset.signupLabel || 'Zapisz się',
      sidebarLimit: parseInt(section.dataset.sidebarLimit || '6', 10),
      allDatesLabel: section.dataset.allDatesLabel || 'Zobacz wszystkie terminy',
      allDatesSheetTitle: section.dataset.allDatesSheetTitle || 'Wszystkie terminy',
      allDatesSheetDescription:
        section.dataset.allDatesSheetDescription || 'Wybierz termin, aby zobaczyć dostępne grupy.',
      emptyGroups: section.dataset.emptyGroups || 'Obecnie nie mamy wyznaczonych terminów zajęć.',
      emptyDates: section.dataset.emptyDates || 'Brak nadchodzących terminów.',
      otherDatesLabel: section.dataset.otherDatesLabel || 'Inne terminy tego kursu',
    };
  }

  function renderMetaItem(icon, text) {
    return `<div class="stationary-groups__meta-item">${META_ICONS[icon]}<span>${escapeHtml(text)}</span></div>`;
  }

  function renderGroupPrices(group) {
    if (!group.priceLabel) return '';

    const originalPrice = group.originalPriceLabel
      ? `<span class="stationary-groups__card-price-original">${escapeHtml(group.originalPriceLabel)}</span>`
      : '';

    return `
      <div class="stationary-groups__card-prices">
        ${originalPrice}
        <span class="stationary-groups__card-price${group.originalPriceLabel ? ' stationary-groups__card-price--promo' : ''}">${escapeHtml(group.priceLabel)}</span>
      </div>
    `;
  }

  function renderGroupCard(group, config, options = {}) {
    const { isActive = false, compact = false, showPrice = !compact } = options;
    const spotsText = group.isFull
      ? 'brak wolnych miejsc'
      : `${group.availableSpots} wolnych miejsc`;
    const calendarIcon = META_ICONS.calendar;

    return `
      <article
        class="stationary-groups__card${isActive ? ' is-active' : ''}${compact ? ' stationary-groups__card--compact' : ''}"
        data-stationary-group-card
        data-group-id="${group.id}"
        data-course-id="${group.courseId}"
      >
        <div class="stationary-groups__card-top">
          <div class="stationary-groups__card-intro">
            <p class="stationary-groups__card-label">${escapeHtml(group.courseTitle)}</p>
            <h3 class="stationary-groups__card-title">${escapeHtml(group.label)}</h3>
            <p class="stationary-groups__card-time">${escapeHtml(group.timeRange)}</p>
          </div>
          <button
            type="button"
            class="stationary-groups__schedule-btn"
            data-stationary-schedule-open
            data-group-id="${group.id}"
            aria-haspopup="dialog"
          >
            ${calendarIcon}
            <span>Terminarz</span>
          </button>
        </div>
        ${showPrice ? renderGroupPrices(group) : ''}
        <div class="stationary-groups__meta-grid">
          ${renderMetaItem('people', `max. ${group.maxStudents} osób`)}
          ${renderMetaItem('clock', group.durationLabel || '')}
          ${renderMetaItem('calendar', `start: ${formatStartDate(group.startDate) || group.startMonthLabel || ''}`)}
          ${renderMetaItem(group.isFull ? 'unavailable' : 'spots', spotsText)}
        </div>
        <a href="${escapeHtml(group.checkoutUrl)}" class="stationary-groups__cta" data-stationary-signup>
          ${escapeHtml(config.signupLabel)}
        </a>
      </article>
    `;
  }

  function formatScheduleDate(dateValue) {
    try {
      return new Date(dateValue).toLocaleDateString('pl-PL', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
      });
    } catch (error) {
      return String(dateValue ?? '');
    }
  }

  function formatStartDate(dateValue) {
    if (!dateValue) return '';
    try {
      return new Date(dateValue).toLocaleDateString('pl-PL', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } catch (error) {
      return String(dateValue);
    }
  }

  function renderScheduleItems(schedules) {
    if (!schedules?.length) {
      return `<p class="stationary-groups__empty">Brak zaplanowanych terminów zajęć.</p>`;
    }

    return [...schedules]
      .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
      .map((schedule) => {
        const teacherName = schedule.teacher?.fullName || 'Prowadzący';
        const teacherImage = schedule.teacher?.image;
        const avatar = teacherImage
          ? `<img src="${escapeHtml(teacherImage)}" alt="${escapeHtml(teacherName)}" width="28" height="28" loading="lazy">`
          : `<span class="stationary-groups__schedule-avatar-fallback" aria-hidden="true">${META_ICONS.people}</span>`;

        return `
          <article class="stationary-groups__schedule-item">
            <div class="stationary-groups__schedule-item-row">
              ${META_ICONS.calendar}
              <span>${escapeHtml(formatScheduleDate(schedule.date))}</span>
            </div>
            <div class="stationary-groups__schedule-item-row">
              ${META_ICONS.clock}
              <span>${escapeHtml(schedule.startHour || '')} - ${escapeHtml(schedule.endHour || '')}</span>
            </div>
            <div class="stationary-groups__schedule-item-row stationary-groups__schedule-item-row--teacher">
              <span class="stationary-groups__schedule-avatar">${avatar}</span>
              <span>${escapeHtml(teacherName)}</span>
            </div>
          </article>
        `;
      })
      .join('');
  }

  function renderDateItem(date, isActive) {
    return `
      <button
        type="button"
        class="stationary-groups__date-item${isActive ? ' is-active' : ''}"
        data-stationary-date-item
        data-date-id="${escapeHtml(date.id)}"
        aria-pressed="${isActive ? 'true' : 'false'}"
      >
        <span class="stationary-groups__date-badge">
          <span class="stationary-groups__date-badge-day">${date.day}</span>
          <span class="stationary-groups__date-badge-month">${escapeHtml(date.monthAbbr)}</span>
        </span>
        <span>
          <p class="stationary-groups__date-title">${escapeHtml(date.courseTitle)}</p>
          <p class="stationary-groups__date-time">${escapeHtml(date.timeRange)}</p>
        </span>
      </button>
    `;
  }

  function buildUpcomingDatesFromGroups(allGroups) {
    return allGroups
      .map((group) => ({
        id: `${group.courseId}-${group.id}-start`,
        courseId: group.courseId,
        groupId: group.id,
        courseTitle: group.courseTitle,
        day: group.day,
        monthAbbr: group.monthAbbr,
        timeRange: group.timeRange,
        startTimestamp: group.startTimestamp || new Date(group.startDate).getTime(),
      }))
      .sort((a, b) => (a.startTimestamp || 0) - (b.startTimestamp || 0));
  }

  function mapUpcomingDate(date) {
    return {
      ...date,
      id: date.id || `${date.courseId}-${date.groupId}-start`,
    };
  }

  function hideLoaders(section) {
    section.querySelectorAll('[data-stationary-loading], [data-stationary-sidebar-loading]').forEach((el) => {
      el.remove();
    });
  }

  function normalizeStorefrontData(data, config) {
    const courseId = parseInt(config.courseId, 10);

    let allGroups = data?.allGroups;
    if (!allGroups?.length && data?.groups?.length) {
      allGroups = data.groups.map((group) => ({
        ...group,
        courseId,
        startTimestamp: new Date(group.startDate).getTime(),
      }));
    }

    const courseGroups = (allGroups || []).filter((group) => group.courseId === courseId);
    let allUpcomingDates = buildUpcomingDatesFromGroups(courseGroups);

    if (!allUpcomingDates.length) {
      allUpcomingDates = (data?.allUpcomingDates || data?.upcomingDates || [])
        .map(mapUpcomingDate)
        .filter((date) => date.courseId === courseId)
        .sort((a, b) => (a.startTimestamp || 0) - (b.startTimestamp || 0));
    }

    const upcomingDates = allUpcomingDates.slice(0, config.sidebarLimit);

    const defaultDateId =
      data?.defaultDateId ||
      upcomingDates[0]?.id ||
      allUpcomingDates[0]?.id ||
      null;

    return {
      allGroups: allGroups || [],
      upcomingDates,
      allUpcomingDates,
      defaultDateId,
    };
  }

  function getAllDates(state) {
    return state.allUpcomingDates?.length ? state.allUpcomingDates : state.upcomingDates;
  }

  function findSelectedDate(state) {
    return getAllDates(state).find((date) => date.id === state.selectedDateId) || null;
  }

  function findSelectedGroup(state) {
    const selectedDate = findSelectedDate(state);
    if (!selectedDate) return null;

    return (
      state.allGroups.find(
        (group) => group.id === selectedDate.groupId && group.courseId === selectedDate.courseId,
      ) || null
    );
  }

  function getOtherCourseGroups(state) {
    const selectedDate = findSelectedDate(state);
    if (!selectedDate) return [];

    const now = Date.now();
    return state.allGroups
      .filter(
        (group) =>
          group.courseId === selectedDate.courseId &&
          group.id !== selectedDate.groupId &&
          group.startTimestamp > now,
      )
      .sort((a, b) => a.startTimestamp - b.startTimestamp);
  }

  function renderTopContent(state) {
    const selectedDate = findSelectedDate(state);
    const selectedGroup = findSelectedGroup(state);

    if (!selectedDate || !selectedGroup) {
      return `<p class="stationary-groups__empty">${escapeHtml(state.config.emptyGroups)}</p>`;
    }

    return `
      <p class="stationary-groups__term-line" data-stationary-term-line>
        Termin: <strong>${selectedDate.day} ${escapeHtml(selectedDate.monthAbbr)}</strong> · ${escapeHtml(selectedDate.courseTitle)}
      </p>
      <div class="stationary-groups__cards" data-stationary-groups-cards>
        ${renderGroupCard(selectedGroup, state.config, { isActive: true })}
      </div>
    `;
  }

  function renderBottomContent(state) {
    const selectedDate = findSelectedDate(state);
    const selectedGroup = findSelectedGroup(state);
    if (!selectedDate || !selectedGroup) return '';

    const otherGroups = getOtherCourseGroups(state);
    if (otherGroups.length === 0) return '';

    return `
      <div class="stationary-groups__other-dates">
        <h3 class="stationary-groups__other-dates-title">${escapeHtml(state.config.otherDatesLabel)}</h3>
        <div class="stationary-groups__other-dates-grid">
          ${otherGroups.map((group) => renderGroupCard(group, state.config, { compact: true })).join('')}
        </div>
      </div>
    `;
  }

  function renderSidebarContent(state) {
    if (state.upcomingDates.length === 0) {
      return `<p class="stationary-groups__empty">${escapeHtml(state.config.emptyDates)}</p>`;
    }

    const datesHtml = state.upcomingDates
      .map((date) => renderDateItem(date, date.id === state.selectedDateId))
      .join('');

    return `
      <div class="stationary-groups__dates" data-stationary-dates>${datesHtml}</div>
      ${
        getAllDates(state).length > 0
          ? `<button type="button" class="stationary-groups__all-dates" data-stationary-all-dates-open>
              ${escapeHtml(state.config.allDatesLabel)} →
            </button>`
          : ''
      }
    `;
  }

  function renderSheetDates(state) {
    const datesHtml = getAllDates(state)
      .map((date) => {
        const isActive = date.id === state.selectedDateId;
        return `
          <div class="stationary-groups__sheet-date" role="presentation">
            ${renderDateItem(date, isActive).replace(
              'data-stationary-date-item',
              'data-stationary-sheet-date-item',
            )}
          </div>
        `;
      })
      .join('');

    return datesHtml;
  }

  const SHEET_CLOSE_MS = 300;

  function getOpenSheet(section) {
    return (
      section.querySelector('[data-stationary-all-dates-sheet].is-open') ||
      section.querySelector('[data-stationary-funding-sheet].is-open') ||
      section.querySelector('[data-stationary-schedule-sheet].is-open')
    );
  }

  function openSheet(section, sheet, focusEl) {
    if (!sheet) return;
    if (sheet.classList.contains('is-open') || sheet.dataset.closing === 'true') return;

    const otherSheet = getOpenSheet(section);
    if (otherSheet && otherSheet !== sheet) {
      closeSheet(section, otherSheet, null, true);
    }

    sheet.hidden = false;
    sheet.classList.remove('is-closing');
    delete sheet.dataset.closing;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        sheet.classList.add('is-open');
      });
    });

    document.body.classList.add('stationary-groups-sheet-open');
    focusEl?.focus();
  }

  function closeSheet(section, sheet, focusBackEl, immediate = false) {
    if (!sheet || sheet.hidden || sheet.dataset.closing === 'true') return;
    if (!sheet.classList.contains('is-open')) {
      sheet.hidden = true;
      if (!getOpenSheet(section)) {
        document.body.classList.remove('stationary-groups-sheet-open');
      }
      return;
    }

    const panel = sheet.querySelector('.stationary-groups__sheet-panel');
    let finished = false;

    const finishClose = () => {
      if (finished) return;
      finished = true;
      panel?.removeEventListener('transitionend', onTransitionEnd);
      sheet.classList.remove('is-open', 'is-closing');
      sheet.hidden = true;
      delete sheet.dataset.closing;
      if (!getOpenSheet(section)) {
        document.body.classList.remove('stationary-groups-sheet-open');
      }
      focusBackEl?.focus();
    };

    if (immediate) {
      finishClose();
      return;
    }

    const onTransitionEnd = (event) => {
      if (event.target !== panel || event.propertyName !== 'transform') return;
      finishClose();
    };

    sheet.dataset.closing = 'true';
    sheet.classList.add('is-closing');
    sheet.classList.remove('is-open');
    if (!getOpenSheet(section)) {
      document.body.classList.remove('stationary-groups-sheet-open');
    }

    panel?.addEventListener('transitionend', onTransitionEnd);
    window.setTimeout(finishClose, SHEET_CLOSE_MS + 50);
  }

  function openAllDatesSheet(section) {
    const state = section._stationaryState;
    const sheet = section.querySelector('[data-stationary-all-dates-sheet]');
    const sheetDates = section.querySelector('[data-stationary-sheet-dates]');
    if (!state || !sheet || !sheetDates) return;

    sheetDates.innerHTML = renderSheetDates(state);
    openSheet(section, sheet, sheet.querySelector('.stationary-groups__sheet-close'));
  }

  function closeAllDatesSheet(section) {
    const sheet = section.querySelector('[data-stationary-all-dates-sheet]');
    const openBtn = section.querySelector('[data-stationary-all-dates-open]');
    closeSheet(section, sheet, openBtn);
  }

  function openFundingSheet(section) {
    const sheet = section.querySelector('[data-stationary-funding-sheet]');
    openSheet(section, sheet, sheet?.querySelector('.stationary-groups__sheet-close'));
  }

  function closeFundingSheet(section) {
    const sheet = section.querySelector('[data-stationary-funding-sheet]');
    const openBtn = section.querySelector('[data-stationary-funding-open]');
    closeSheet(section, sheet, openBtn);
  }

  async function fetchGroupSchedules(backendUrl, groupId) {
    const response = await fetch(`${backendUrl}/group-schedules/group/${groupId}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch schedules (${response.status})`);
    }
    const data = await response.json();
    return Array.isArray(data) ? data : [];
  }

  async function openScheduleSheet(section, groupId) {
    const state = section._stationaryState;
    const config = getConfig(section);
    const sheet = section.querySelector('[data-stationary-schedule-sheet]');
    const titleEl = section.querySelector('[data-stationary-schedule-title]');
    const listEl = section.querySelector('[data-stationary-schedule-list]');
    if (!state || !sheet || !listEl) return;

    const group =
      state.allGroups.find((item) => String(item.id) === String(groupId)) || null;
    if (!group) return;

    if (titleEl) {
      titleEl.textContent = `Terminarz - ${group.label || ''}`.trim();
    }
    sheet.dataset.activeGroupId = String(group.id);
    openSheet(section, sheet, sheet.querySelector('.stationary-groups__sheet-close'));

    if (Array.isArray(group.schedules) && group.schedules.length > 0) {
      listEl.innerHTML = renderScheduleItems(group.schedules);
      return;
    }

    listEl.innerHTML = `<p class="stationary-groups__empty">Ładowanie terminarza…</p>`;

    try {
      const schedules = await fetchGroupSchedules(config.backendUrl, group.id);
      group.schedules = schedules;
      if (sheet.dataset.activeGroupId !== String(group.id)) return;
      listEl.innerHTML = renderScheduleItems(schedules);
    } catch (error) {
      if (sheet.dataset.activeGroupId !== String(group.id)) return;
      listEl.innerHTML = `<p class="stationary-groups__empty">Nie udało się pobrać terminarza.</p>`;
    }
  }

  function closeScheduleSheet(section) {
    const sheet = section.querySelector('[data-stationary-schedule-sheet]');
    const openBtn = section.querySelector(
      `[data-stationary-schedule-open][data-group-id="${sheet?.dataset.activeGroupId || ''}"]`,
    );
    closeSheet(section, sheet, openBtn);
  }

  function playFundingVideo(section) {
    const cover = section.querySelector('[data-stationary-funding-video-play]');
    const iframe = section.querySelector('[data-stationary-funding-video-iframe]');
    if (!cover || !iframe) return;

    const src = iframe.getAttribute('src') || '';
    if (src.includes('autoplay=false')) {
      iframe.setAttribute('src', src.replace('autoplay=false', 'autoplay=true'));
    }
    cover.hidden = true;
  }

  function highlightSignupCard(section) {
    const card =
      section.querySelector('[data-stationary-top-content] [data-stationary-group-card].is-active') ||
      section.querySelector('[data-stationary-top-content] [data-stationary-group-card]');
    if (!card) return;

    card.classList.remove('is-highlighted');
    // Force reflow so the animation can restart when selecting consecutive dates.
    void card.offsetWidth;
    card.classList.add('is-highlighted');

    const clearHighlight = () => {
      card.classList.remove('is-highlighted');
      card.removeEventListener('animationend', clearHighlight);
    };
    card.addEventListener('animationend', clearHighlight);
    window.setTimeout(clearHighlight, 1600);
  }

  function scrollToSignupCard(section) {
    const card =
      section.querySelector('[data-stationary-top-content] [data-stationary-group-card].is-active') ||
      section.querySelector('[data-stationary-top-content] [data-stationary-group-card]');
    if (!card) return;

    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    highlightSignupCard(section);
  }

  function selectDate(section, dateId, options = {}) {
    const { closeSheet = false, scrollToSignup = false } = options;
    const state = section._stationaryState;
    if (!state || !dateId) return;

    state.selectedDateId = dateId;
    renderSection(section);

    if (closeSheet) {
      closeAllDatesSheet(section);
      if (scrollToSignup) {
        window.setTimeout(() => scrollToSignupCard(section), SHEET_CLOSE_MS + 80);
      }
    } else {
      if (section.querySelector('[data-stationary-all-dates-sheet].is-open')) {
        const sheetDates = section.querySelector('[data-stationary-sheet-dates]');
        if (sheetDates) {
          sheetDates.innerHTML = renderSheetDates(state);
        }
      }
      if (scrollToSignup) {
        requestAnimationFrame(() => scrollToSignupCard(section));
      }
    }
  }

  function bindDateSelection(section) {
    if (section.dataset.stationaryClicksBound) return;
    section.dataset.stationaryClicksBound = 'true';

    section.addEventListener('click', (event) => {
      const sidebarDate = event.target.closest('[data-stationary-date-item]');
      if (sidebarDate) {
        selectDate(section, sidebarDate.dataset.dateId, { scrollToSignup: true });
        return;
      }

      const sheetDate = event.target.closest('[data-stationary-sheet-date-item]');
      if (sheetDate) {
        selectDate(section, sheetDate.dataset.dateId, { closeSheet: true, scrollToSignup: true });
        return;
      }

      if (event.target.closest('[data-stationary-all-dates-open]')) {
        openAllDatesSheet(section);
        return;
      }

      if (event.target.closest('[data-stationary-sheet-close]')) {
        closeAllDatesSheet(section);
        return;
      }

      if (event.target.closest('[data-stationary-funding-open]')) {
        openFundingSheet(section);
        return;
      }

      if (event.target.closest('[data-stationary-funding-close]')) {
        closeFundingSheet(section);
        return;
      }

      const scheduleOpen = event.target.closest('[data-stationary-schedule-open]');
      if (scheduleOpen) {
        event.preventDefault();
        openScheduleSheet(section, scheduleOpen.dataset.groupId);
        return;
      }

      if (event.target.closest('[data-stationary-schedule-close]')) {
        closeScheduleSheet(section);
        return;
      }

      if (event.target.closest('[data-stationary-funding-video-play]')) {
        playFundingVideo(section);
      }
    });
  }

  function bindSheetEscape(section) {
    if (section.dataset.sheetEscapeBound) return;
    section.dataset.sheetEscapeBound = 'true';

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const datesSheet = section.querySelector('[data-stationary-all-dates-sheet].is-open');
      if (datesSheet) {
        closeAllDatesSheet(section);
        return;
      }
      const fundingSheet = section.querySelector('[data-stationary-funding-sheet].is-open');
      if (fundingSheet) {
        closeFundingSheet(section);
        return;
      }
      const scheduleSheet = section.querySelector('[data-stationary-schedule-sheet].is-open');
      if (scheduleSheet) closeScheduleSheet(section);
    });
  }

  function renderSection(section) {
    const state = section._stationaryState;
    if (!state) return;

    hideLoaders(section);

    const topContentEl = section.querySelector('[data-stationary-top-content]');
    const bottomContentEl = section.querySelector('[data-stationary-bottom-content]');
    const sidebarContentEl = section.querySelector('[data-stationary-sidebar-content]');

    if (topContentEl) {
      topContentEl.innerHTML = renderTopContent(state);
      topContentEl.hidden = false;
    }

    if (bottomContentEl) {
      bottomContentEl.innerHTML = renderBottomContent(state);
      bottomContentEl.hidden = false;
    }

    if (sidebarContentEl) {
      sidebarContentEl.innerHTML = renderSidebarContent(state);
    }

    if (section.querySelector('[data-stationary-all-dates-sheet].is-open')) {
      const sheetDates = section.querySelector('[data-stationary-sheet-dates]');
      if (sheetDates) {
        sheetDates.innerHTML = renderSheetDates(state);
      }
    }

    bindDateSelection(section);
    bindSheetEscape(section);
  }

  async function fetchStorefrontData(backendUrl, courseId, sidebarLimit) {
    const response = await fetch(
      `${backendUrl}/shopify/courses/${courseId}/storefront?upcomingLimit=${sidebarLimit}`,
      {
        method: 'GET',
        headers: { Accept: 'application/json' },
      },
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    return response.json();
  }

  async function initStationaryCourseGroups(section) {
    if (typeof window.initStationaryCourseGallery === 'function') {
      window.initStationaryCourseGallery(section);
    }
    const config = getConfig(section);
    const errorEl = section.querySelector('[data-stationary-error]');
    const topContentEl = section.querySelector('[data-stationary-top-content]');
    const bottomContentEl = section.querySelector('[data-stationary-bottom-content]');
    const sidebarContentEl = section.querySelector('[data-stationary-sidebar-content]');

    if (!config.courseId) {
      hideLoaders(section);
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = config.emptyGroups;
      }
      if (sidebarContentEl) {
        sidebarContentEl.innerHTML = `<p class="stationary-groups__empty">${escapeHtml(config.emptyDates)}</p>`;
      }
      return;
    }

    try {
      const payload = await fetchStorefrontData(config.backendUrl, config.courseId, config.sidebarLimit);
      const normalized = normalizeStorefrontData(payload.data, config);

      hideLoaders(section);
      if (errorEl) errorEl.hidden = true;

      section._stationaryState = {
        config,
        allGroups: normalized.allGroups,
        upcomingDates: normalized.upcomingDates,
        allUpcomingDates: normalized.allUpcomingDates,
        selectedDateId: normalized.defaultDateId,
      };

      if (topContentEl) topContentEl.hidden = false;
      if (bottomContentEl) bottomContentEl.hidden = false;
      renderSection(section);
    } catch (error) {
      console.error('Stationary groups fetch failed:', error);
      hideLoaders(section);
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = config.emptyGroups;
      }
      if (sidebarContentEl) {
        sidebarContentEl.innerHTML = `<p class="stationary-groups__empty">${escapeHtml(config.emptyDates)}</p>`;
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.stationary-groups[data-section-id]').forEach(initStationaryCourseGroups);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.stationary-groups[data-section-id]');
    if (section) initStationaryCourseGroups(section);
  });
})();
